import { useQuery } from "@tanstack/react-query";

import { getFieldRedzones } from "services";

import { GET_FIELD_REDZONES } from "consts";

import { FieldRedzone } from "models";

export const useGetFieldRedzones = ({ enabled = true }: { enabled?: boolean } = {}) =>
  useQuery<FieldRedzone[]>({
    queryKey: [GET_FIELD_REDZONES],
    queryFn: ({ signal }) => getFieldRedzones({ signal }),
    enabled,
  });
